import { render } from "./notification-status.vue?vue&type=template&id=76bef471&ts=true"
import script from "./notification-status.ts?vue&type=script&lang=ts&external"
export * from "./notification-status.ts?vue&type=script&lang=ts&external"

import "./notification-status.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__